module.exports = __webpack_public_path__ + "static/media/reception.d176da58.png";